import styled, { css } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Box, Flex, Stack } from "@similarweb/ui-components/foundations";

const PAGE_CONTENT_WIDTH = "900px";

export const StyledCrmEnrichmentWizardContainer = styled(Stack)`
    height: 100vh;
    overflow: hidden;
`;

export const StyledCrmEnrichmentWizardLegend = styled.div`
    width: 614px;
    margin: 60px auto 0;
    & > div {
        animation: none;
    }
`;

export const StyledCrmEnrichmentWizardContent = styled.div<{ $isFillHeight?: boolean }>`
    flex: 1;
    min-height: 0;
    width: ${PAGE_CONTENT_WIDTH};
    box-sizing: border-box;
    margin: 14px auto 0;
    padding: 32px 32px 22px;
    border-radius: 6px 6px 0 0;
    background-color: ${colorsPalettes.carbon[0]};
    box-shadow: 0px 3px 6px 0px rgba(14, 30, 62, 0.08);

    ${({ $isFillHeight }) =>
        $isFillHeight
            ? css`
                  display: flex;
                  flex-direction: column;
                  overflow: hidden;
              `
            : css`
                  overflow: auto;
              `}
`;

export const StyledFooterWrapper = styled(Flex)`
    width: 100%;
    justify-content: space-between;
    background-color: ${colorsPalettes.carbon[0]};
    border-top: 1px solid ${colorsPalettes.carbon[100]};
`;

export const StyledCrmEnrichmentJobSetting = styled.div`
    position: relative;
    width: 224px;
`;

export const StyledRefreshDataIntervalDisabledState = styled(Flex)`
    align-items: flex-start;
    gap: 4px;
    width: fit-content;
    max-width: 100%;
    padding: 6px 12px 6px 8px;
    border-radius: 4px;
    border: 1px solid ${colorsPalettes.midnight["50"]};
    background: ${colorsPalettes.bluegrey["100"]};
`;

export const StyledScheduleDropdownWrapper = styled.div`
    flex: 1;
    min-width: 0;
`;

export const StyledCrmEnrichmentJobDropdownWrapper = styled(StyledScheduleDropdownWrapper)`
    position: relative;
`;

export const StyledBannerWrapper = styled(Box)`
    width: ${PAGE_CONTENT_WIDTH};
    margin: 0 auto;
`;
